import React from 'react';

import Indicator from './Indicator';

export default ({ images, currentIndex, changeCurrentIndex, event }) => (
  <React.Fragment>
    {images.map((image, index) => (
      <Indicator
        key={image}
        index={index}
        currentIndex={currentIndex}
        changeCurrentIndex={changeCurrentIndex}
        event={event}
      />
    ))}
  </React.Fragment>
);
